import styled from "styled-components";
import { primaryColor, primaryColorHover } from "../../../../config/constants";

export const MainContainer = styled.div`
  margin: 0 0 20px;
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  background-color: #f2f2f2;
  position: relative;
`;
export const ManagementDiv = styled.div`
  padding: 0 10px;
  width: 100%;
  max-width: 860px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent && justifyContent};
  @media (max-width: 910px) {
    width: 85%;
  }
  @media (max-width: 570px) {
    justify-content: flex-start;
  }
  @media (max-width: 400px) {
    margin: 0;
  }
`;
export const SaveAndCancelDiv = styled.div`
  height: 40px;
  display: flex;
`;
export const SaveButton = styled.button`
  margin-right: 10px;
  width: 108px;
  border: none;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background-color: ${primaryColor};
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
`;
export const CancelButton = styled.button`
  padding: 10px;
  width: 108px;
  border: 1px solid ${primaryColor};
  border-radius: 5px;
  color: ${primaryColor};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background: transparent;
  outline: none;
  cursor: pointer;
`;
